import { useEffect, useState } from 'react';

// Must match $mobile-view-breakpoint in src/scss/variables.scss — the CSS
// below that width already renders the chat full-screen; the JS takeover
// (MobileTakeover) keys off the same query. Width-only drives layout.
export const MOBILE_MEDIA_QUERY = '(max-width: 800px)';
// The touch variant drives keyboard behaviours (takeover on focus, autofocus,
// blur after send) so desktop users in narrow windows or iframes keep a
// focused composer and no blur after send.
export const MOBILE_TOUCH_MEDIA_QUERY = '(max-width: 800px) and (pointer: coarse)';

function getMql(query: string): MediaQueryList | null {
    return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
        ? window.matchMedia(query)
        : null;
}

function useMediaQuery(query: string): boolean {
    const [matches, setMatches] = useState<boolean>(() => getMql(query)?.matches ?? false);

    useEffect(() => {
        const mql = getMql(query);
        if (!mql) return undefined;
        const onChange = (e: { matches: boolean }) => setMatches(e.matches);
        setMatches(mql.matches);
        mql.addEventListener('change', onChange);
        return () => mql.removeEventListener('change', onChange);
    }, [query]);

    return matches;
}

export function useIsMobile(): boolean {
    return useMediaQuery(MOBILE_MEDIA_QUERY);
}

export function useIsTouchMobile(): boolean {
    return useMediaQuery(MOBILE_TOUCH_MEDIA_QUERY);
}
